import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import qs from 'query-string';
import Immutable from 'immutable';
import ScrollView from './ScrollView';
import NavigationVertical from './Navigation/Vertical';
import Header from '../Header';
import Stack from '../Stack';

import { usePrevious } from '../../helpers/usePrevious';

import './style.scss';

const SliderPage = ({ entity }) => {
  const [activeIndex, _setActiveIndex] = useState(0);
  const previousIndex = usePrevious(activeIndex);
  const isAnimating = useRef(false);
  const history = useHistory();
  const queryStringValues = qs.parse(window.location.search);

  const introTitle = entity.getIn(['title', 0, 'value']);
  const introBody = entity.getIn(['field_ondertitel', 0, 'value']);
  const introBackgroundImage = entity.getIn(['field_hero_image', 0, 'styles', 'annual_overview_8_9']);
  const introBackgroundImageMobile = entity.getIn(['field_hero_image', 0, 'styles', 'crop_1_1']);

  const outroTitle = entity.getIn(['field_outro_titel', 0, 'value']);
  const outroBody = entity.getIn(['field_outro_body', 0, 'value']);

  const pages = entity.getIn(['field_paragraphs']);

  useEffect(() => {
    if (queryStringValues.section) {
      const index = pages.findIndex((page) => page.getIn(['entity', 'field_title', 0, 'value']) === queryStringValues.section);
      setActiveIndex(index + 1);
    }
  }, [queryStringValues, pages]);

  const setActiveIndex = (index) => {
    if (isAnimating.current) {
      return;
    }

    isAnimating.current = true;
    _setActiveIndex(index);

    // Set the active section on our URL so we can redirect to it.
    const sectionTitle = pages.get(index - 1, Immutable.Map()).getIn(['entity', 'field_title', 0, 'value'], null);
    if (sectionTitle) history.push(`?section=${encodeURIComponent(sectionTitle)}`);

    setTimeout(() => {
      isAnimating.current = false;
    }, 1000);
  };

  const onNext = () => {
    setActiveIndex(activeIndex + 1);
  };

  const onPrev = () => {
    // Boundary check.
    if (activeIndex === 0) {
      return;
    }
    setActiveIndex(activeIndex - 1);
  };

  const onGoto = (index) => {
    setActiveIndex(index);
  };

  const onGotoSubTheme = (index) => {
    setActiveIndex(index + 1);
  };

  return (
    <>
      <Header introTitle={introTitle}
      />
      <ScrollView onNext={onNext} onPrev={onPrev}>
        <Stack
          introTitle={introTitle}
          introBody={introBody}
          introBackgroundImage={introBackgroundImage}
          introBackgroundImageMobile={introBackgroundImageMobile}
          outroTitle={outroTitle}
          outroBody={outroBody}
          activeIndex={activeIndex}
          previousIndex={previousIndex}
          onGoto={onGoto}
          pages={pages}
        />
      </ScrollView>
      <NavigationVertical
        pages={pages}
        index={activeIndex - 1}
        onGoto={onGotoSubTheme}
      />
    </>
  );
};

export default SliderPage;
